import * as React from "react";
import { useSelector } from "react-redux";
import { isRequestActive } from "redux-request-loading";
import { Modal, Loader } from "semantic-ui-react";

import { taskSelector } from "../../../task/selectors";
import { loadOhCaseDetail } from "../../../crud/ohCase/actions";
import {
    routeIdSelector as ohCaseIdSelector,
    ppqDeclarationIdSelector
} from "../../../crud/ohCase/selectors";
import { routeIdSelector as customerIdSelector } from "../../../crud/customer/selectors";
import { LOAD_OHCASE_DETAIL } from "../../../crud/ohCase/actiontypes";
import { ApplicationState } from "../../../applicationState";

import { ViewPpqDeclarationReviewModal } from "./ViewPpqDeclarationReviewModal";
import { PpqDeclarationReviewModal } from "./PpqDeclarationReviewModal";

const PpqDeclarationReview: React.FunctionComponent = () => {
    const ohCaseId = useSelector(ohCaseIdSelector);
    const customerId = useSelector(customerIdSelector);
    const task = useSelector(taskSelector);
    const loading = useSelector((state: ApplicationState) => isRequestActive(state, LOAD_OHCASE_DETAIL));
    const ppqDeclarationId = useSelector(ppqDeclarationIdSelector);

    React.useEffect(() => {
        if (!task) {
            loadOhCaseDetail({ ohCaseId, customerId });
        }
    }, []);

    if (loading) {
        return <Modal><Loader active /></Modal>;
    }

    if (task.completed) {
        return <ViewPpqDeclarationReviewModal customerId={customerId} ohCaseId={ohCaseId} taskId={task.id} ppqId={ppqDeclarationId} />;
    }

    return <PpqDeclarationReviewModal customerId={customerId} ohCaseId={ohCaseId} taskId={task.id} ppqId={ppqDeclarationId} />;
};

export { PpqDeclarationReview };
